




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { PushTemplate, FetchUsersPayload } from '../utils/types'
import { makeGqlRequest, translateAgeGroupsToDates } from '../utils/helpers'
import { getPushTemplates } from '../utils/queries'
import { sendPushNotification } from '../utils/mutations'
import { createPushTemplate } from '../utils/api'

@Component
export default class SendPushDialog extends Vue {
  @Prop({ type: Object, required: true }) filters!: FetchUsersPayload
  @Getter jwt!: string

  isTemplatesLoading = false
  isSendingPush = false
  pushOption: 'existing' | 'manual' = 'existing'
  selectedTemplateId = ''
  activeTemplates: PushTemplate[] = []
  manualTitle = ''
  manualContent = ''
  manualLink = ''

  get selectedTemplate() {
    return this.activeTemplates.find(t => t.id === this.selectedTemplateId) || null
  }

  async mounted() {
    await this.fetchTemplates()
  }

  async fetchTemplates() {
    this.isTemplatesLoading = true
    try {
      const res = await makeGqlRequest(
        getPushTemplates,
        {
          isArchived: false,
          limit: 100,
          page: 1
        },
        this.jwt
      )
      this.activeTemplates = res.pushTemplates?.templates || []
    } catch (err) {
      this.activeTemplates = []
    } finally {
      this.isTemplatesLoading = false
    }
  }

  emitClose() {
    this.$emit('close')
  }

  private mapFiltersToWhere(filters: FetchUsersPayload): Record<string, unknown> {
    const where: Record<string, unknown> = {}
    if (filters.searchText) where.searchText = filters.searchText
    if (filters.isInFocusGroup) where.isInFocusGroup = filters.isInFocusGroup
    if (filters.createdAtGte) where.createdAtGte = filters.createdAtGte
    if (filters.lastActivityGte) where.lastActivityGte = filters.lastActivityGte
    if (filters.lastShiftLogGte) where.lastShiftLogGte = filters.lastShiftLogGte
    if (filters.closestArea) where.closestArea = filters.closestArea
    if (filters.authority) where.authority = filters.authority
    if (filters.roles && filters.roles.length) where.roles = filters.roles

    if (filters.ages) {
      const ageDates = translateAgeGroupsToDates(filters.ages)
      if (ageDates.lte) where.birthdayLte = ageDates.lte
      if (ageDates.gt) where.birthdayGt = ageDates.gt
    }
    return where
  }

  async sendPush() {
    if (this.pushOption === 'manual') {
      const form = this.$refs.pushForm as Vue & { validate: () => boolean }
      if (!form.validate()) {
        return
      }
    }

    this.isSendingPush = true
    try {
      let templateId = this.selectedTemplateId
      if (this.pushOption === 'manual') {
        const res = await createPushTemplate(
          {
            title: this.manualTitle,
            content: this.manualContent,
            link: this.manualLink || null
          },
          this.jwt
        )
        templateId = res.id
      }

      const where = this.mapFiltersToWhere(this.filters)

      await makeGqlRequest(
        sendPushNotification,
        {
          where,
          templateId
        },
        this.jwt
      )

      this.$emit('success', 'הודעת הפוש נשלחה בהצלחה!')
      this.emitClose()
    } catch (err) {
      this.$emit('error', 'שגיאה בשליחת הודעת הפוש: ' + (err.message || err))
    } finally {
      this.isSendingPush = false
    }
  }
}
